
<component v-if="helpText" :is="tag" class="tooltip-btn" :class="[setColor, direction]" :data-c-tooltip-class="direction" v-bind="bindings" v-tooltip:[tooltipArg]="helpText">
  <icon :class="setIcon"></icon>
  <span class="sr-only">
    <slot>{{helpText}}</slot>
  </span>
</component>
